// @flow

const inputElement = (e: EventTarget) =>
  ((e: any): HTMLInputElement)

module.exports = { inputElement }




// WEBPACK FOOTER //
// ./src/eventtypes.js